import translations from '../it.json';

window.I18n.store(translations);
window.I18n.default_locale = 'it';
window.I18n.locale = 'it';

/* satisfy vite compiler  */
export default {};